/* Free comic toploader: keeps one free toploader line in the cart while the cart has a comic and reaches the spend.
   Config comes from sections/ds-toploader.liquid (window.dsToploader). Shopify's automatic discount makes the line $0.
   window.dsToploaderSync() -> Promise<boolean> (true when it added or removed the line). */
(function () {
  var C = window.dsToploader;
  if (!C || window.dsToploaderSync) return;
  var running = null;

  function json(url, body) {
    return fetch(C.root + url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { if (!r.ok) throw r; return r.json(); });
  }
  function isFree(i) { return i.variant_id === C.variant && i.properties && i.properties[C.key]; }
  function isComic(i) {
    if (i.product_id === C.product || C.skip.indexOf(i.product_id) > -1) return false;
    var t = (i.product_type || '').toLowerCase();
    if (t === 'comic book' || t === 'comic books') return true;
    return t === '' && /#\s*\d/.test(i.product_title || i.title || '');
  }
  // spend that counts toward the perk: everything except toploaders
  function spend(cart) {
    return cart.items.reduce(function (s, i) { return i.variant_id === C.variant ? s : s + i.final_line_price; }, 0);
  }

  function sync() {
    if (running) return running;
    running = json('cart.js').then(function (cart) {
      var free = cart.items.filter(isFree)[0];
      var comics = cart.items.some(isComic);
      var want = comics && spend(cart) >= C.min;
      if (want && !free) {
        var props = {}; props[C.key] = C.value;
        return json('cart/add.js', { items: [{ id: C.variant, quantity: 1, properties: props }] })
          .then(function () { return true; }, function () { return false; }); // out of stock: skip quietly
      }
      if (!want && free) {
        return json('cart/change.js', { id: free.key, quantity: 0 }).then(function () { return true; });
      }
      if (free && free.quantity > 1) {
        return json('cart/change.js', { id: free.key, quantity: 1 }).then(function () { return true; });
      }
      return false;
    }).catch(function () { return false; }).then(function (changed) { running = null; return changed; });
    return running;
  }
  window.dsToploaderSync = sync;

  function start() {
    // after any add-to-cart / quantity change (Dawn pub/sub); the cart page handles its own refresh
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        if (document.querySelector('[data-dsa]')) return;
        sync();
      });
    }
    if (!document.querySelector('[data-dsa]')) sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
